import { createAction, props } from '@ngrx/store';
import { DrawnItem } from '../reducers/map-draw.reducer';

export const addItem = createAction(
	'[Map Draw] Add Item',
	props<{ item: DrawnItem }>()
);

export const addItems = createAction(
	'[MapDraw] Add Items',
	props<{ items: DrawnItem[] }>()
);

export const removeItem = createAction(
	'[Map Draw] Remove Item',
	props<{ itemId: string }>()
);

export const clearAll = createAction(
	'[Map Draw] Clear All'
);

export const updateBounds = createAction('[Map Draw] Update Bounds');

export const updateBoundsSuccess = createAction(
	'[Map Draw] Update Bounds Success',
	props<{ bounds: any }>()
);
